




































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleteClinicStates from '@/components/simple-therapy/autocomplete-clinic-states.vue';
import UiAutocompleteClinicsSituations from '@/components/simple-therapy/autocomplete-clinics-situations.vue';
import UiRadioGroupsNPTs from '@/components/simple-therapy/radiogroup-npts.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { FiltroSituacaoClinicaDTO, UsoTerapiaSimplifFiltro } from '@/interfaces/therapy';
import { listSimpleTherapyPrescription } from '@/services/prescription';
import { listNutritionOffers, listTnDaysSimpleTherapy } from '@/services/therapy';
import { ADMINISTRATION_WAYS_CENTRAL, ADMINISTRATION_WAYS_PERIPHERAL } from '@/settings/consts/prescription-params';
import { VueMaskDirective } from 'v-mask';
import Component from 'vue-class-component';
import { CurrencyDirective, CurrencyInputOptions, parseCurrency } from 'vue-currency-input';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiRadioGroupsNPTs,
    UiAutocompleteClinicsSituations,
    ListMessages,
    UiAutocompleteClinicStates,
  },
  directives: {
    currency: CurrencyDirective,
    mask: VueMaskDirective,
  },
})
export default class SimplifiedPrescriptionDialog extends BaseComponent {
  @Prop()
  public item;

  @Prop()
  public imc;

  dialogFlag = false;

  dto = new UsoTerapiaSimplifFiltro();
  NPT_EXCLUSIVA = 'E';
  VIA_PERIFERICA = ADMINISTRATION_WAYS_PERIPHERAL;
  VIA_CENTRAL = ADMINISTRATION_WAYS_CENTRAL;
  ofertas = [];
  ofertasLoading = false;
  tndays = [];
  tndaysLoading = false;
  viaAdministracaoEnabled = false;

  filtersSitClinics: FiltroSituacaoClinicaDTO = null;

  maskAltura: CurrencyInputOptions = {
    currency: { prefix: '', suffix: ' m' },
    locale: 'pt-BR',
    precision: { min: 2, max: 2 },
    autoDecimalMode: true,
    valueRange: { max: 3 },
    allowNegative: false,
  };

  alturaPaciente = null;

  public form: any = {
    valid: false,
    rules: {
      altura: [(v) => (v != null && v.length > 0) || 'Informe a Altura do Paciente'],
      administracao: [(v) => v != null || 'Informe a Via de Administração'],
      suplementar: [(v) => v != null || 'Informe o Tipo'],
      ofertas: [(v) => v != null || 'Informe a Oferta Nutricional'],
      tndays: [(v) => v != null || 'Informe os Dias em Nutrição Parenteral'],
      idEstadoClinico: [(v) => v != null || 'Informe o Estado Clínico'],
      sitClinic: [(v) => (v != null && v.length > 0) || 'Informe uma ou mais Situações Clínicas'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: '', value: '', align: 'center', sortable: false, width: '10px' },
    { text: 'Fórmula', value: 'nome', sortable: false },
    { text: 'Descrição', value: 'descricao', sortable: false },
  ];

  loading = false;
  error = false;
  items = null;
  therapySelected = null;

  mounted() {
    setTimeout(() => {
      this.dialogFlag = true;
    }, 100);
    this.loadNutritionOffers();
    this.loadTnDays();

    setTimeout(() => {
      this.$refs['alturaPaciente'].focus();
    }, 200);
  }

  private loadNutritionOffers() {
    this.ofertasLoading = true;

    listNutritionOffers().subscribe(
      (res) => {
        this.ofertas = res;
        this.ofertasLoading = false;
      },
      (error) => {
        this.ofertasLoading = false;
        this.showToastApiError(error);
      },
    );
  }

  private loadTnDays() {
    this.tndaysLoading = true;
    listTnDaysSimpleTherapy().subscribe(
      (res) => {
        this.tndays = res;
        this.tndaysLoading = false;
      },
      (error) => {
        this.tndaysLoading = false;
        this.showToastApiError(error);
      },
    );
  }

  closeForm() {
    this.$emit('changePatientHeight', null);
    this.$emit('cancel');
    this.dialogFlag = false;
  }

  isFilterReady() {
    this.$refs.form.validate();
    let dto = this.dto;
    return (
      this.alturaPaciente &&
      dto.viaAdministracao &&
      dto.npt &&
      ((dto.npt !== this.NPT_EXCLUSIVA && dto.ofertaNutricional) ||
        (dto.npt === this.NPT_EXCLUSIVA &&
          dto.diasTN &&
          dto.idEstadoClinico &&
          dto.idsSituacoesClinicas &&
          dto.idsSituacoesClinicas.length > 0))
    );
  }

  listTimeout = null;
  listSimpleTherapies() {
    clearTimeout(this.listTimeout);
    this.listTimeout = setTimeout(() => {
      this.listSimpleTherapiesTimeout();
    }, 500);
  }

  listSimpleTherapiesTimeout() {
    this.loading = false;
    this.error = false;

    this.items = null;
    if (!this.isFilterReady()) {
      return;
    }

    if (this.dto.npt === this.NPT_EXCLUSIVA) {
      this.dto.ofertaNutricional = null;
    } else {
      this.dto.idsSituacoesClinicas = [];
      this.dto.diasTN = null;
    }
    this.dto.idUnidade = this.item.unidade.id;

    this.loading = true;
    listSimpleTherapyPrescription(this.dto).subscribe(
      (res) => {
        this.loading = false;
        this.items = res;
      },
      (error) => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  @Watch('therapySelected')
  onChangeTherapy(val, old) {
    this.$emit('input', val, this.dto.diasTN);
    this.$emit('change', val, this.dto.diasTN);

    setTimeout(() => {
      this.dialogFlag = false;
    }, 200);
  }

  @Watch('dto.npt')
  onNptChange(v) {
    if (v == this.NPT_EXCLUSIVA) {
      this.dto.viaAdministracao = this.VIA_CENTRAL;
      this.viaAdministracaoEnabled = false;
    } else {
      this.dto.viaAdministracao = null;
      this.viaAdministracaoEnabled = true;
    }
  }

  @Watch('dto.viaAdministracao')
  @Watch('dto.idEstadoClinico')
  @Watch('dto.idsSituacoesClinicas')
  onFiltersSitClinicChange() {
    let filter = new FiltroSituacaoClinicaDTO();
    filter.idUnidade = this.item.unidade.id;
    filter.viaAdministracao = this.dto.viaAdministracao;
    filter.idEstadoClinico = this.dto.idEstadoClinico;
    filter.idsSituacoesClinicas = this.dto.idsSituacoesClinicas;

    setTimeout(() => {
      this.filtersSitClinics = filter;
    }, 50);
  }

  onAlturaChange() {
    if (!this.alturaPaciente) {
      this.$emit('changePatientHeight', null);
    }
    this.$emit('changePatientHeight', parseCurrency(this.alturaPaciente, this.maskAltura));
    this.listSimpleTherapies();
  }

  openFile(url) {
    window.open(url, 'educativoPesoAjustado');
  }
}
